import React from "react";
import { Navbar } from "./NavBar";
import Hackatons from "../components/Hackatons";
import Footer from "./home/Footer";

export const Challenge = () => {
  return (
    <div>
     <Navbar />
      <Hackatons />
      <Footer />
      
    </div>
  );
};
